import React, { useEffect, useContext, useRef, useState } from "react";
import { Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingOverlay from "react-loading-overlay";
import { useTranslation } from "react-i18next";
import Drawer from "@material-ui/core/Drawer";
import { isMobile } from "react-device-detect";
import Spinner from "react-bootstrap/Spinner";
import ReactGA from "react-ga";

import AuthLoader from "../Auth/AuthLoader";
import Header from "./components/Header/Header";
import {
  ButtonGroup,
  Container,
  TapButton,
  HomeButton,
} from "./components/Header/HeaderStyles";
import Footer from "./components/Footer/Footer";
import AcceptCookie from "../../components/AcceptCookie";
import AssetListScreen from "./screens/AssetListScreen/AssetListScreen";
import AuthLanding from "../Auth/Landing";
import NotFound from "../General/NotFound";
import Nameplate from "../Auth/Nameplate";
import VIPDonation from "../Auth/VIPDonation";
import DonationForm from "../Auth/DonationForm";
import DonorImage from "../Payment/DonorImage";
import Payment from "../Payment/Payment/";
import Complete from "../Payment/Complete/";
import ScrollToTop from "../Wrapper/ScrollToTop";
import { reducer } from "../../context";
import actionType from "../../context/actionType";
import Api from "../../helpers/Api";
import { RecaptchaLg } from "../../enum/";
import i18n_address from "../../i18n_addr";
import CIAMWrapper from "../../scenes/assets/CIMAWrapper";

const AssetWrapper = () => {
  const { i18n } = useTranslation();
  const { i18n: i18n_addr } = useTranslation(null, { i18n: i18n_address });
  const { configReducer } = useContext(reducer);
  const [showMenu, setShowMenu] = useState(false); // TODO: add listener to hide menu when clicking outside of menu
  const useChinese = i18n.language === "zhTW" || i18n.language === "cn";
  useEffect(() => {
    const baseUrlSplit = window.location.href.split(window.location.host);
    if (
      !(!baseUrlSplit[1] || baseUrlSplit[1] !== "/") ||
      !(baseUrlSplit[1] || baseUrlSplit[1] == "/donation/")
    ) {
      return; // not at root / AssetListScreen do not run getByPath for menu
    }

    // set language if in URL otherwise use default i18n.langauge and if different update i18n
    // TODO: maybe should be moved to a seaprate component / listener (separate concerns)
    const searchParams = new URLSearchParams(document.location.search);
    let lng = i18n.language;
    const storedLng = sessionStorage.getItem("language");
    if (storedLng) {
      lng = storedLng;
    }
    if (searchParams.has("lng")) {
      const paramLng = searchParams.get("lng");
      if (paramLng === "cn") lng = "cn";
      if (paramLng === "hk") lng = "zhTW";
      if (paramLng === "en") lng = "en";
    }
    if (lng !== i18n.language) {
      i18n.changeLanguage(lng);
    }
    if (lng !== i18n_addr.language) {
      i18n_addr.changeLanguage(lng);
    }
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };
    const endpoint = lng === "en" ? "en-US" : lng === "cn" ? "cn" : "zh-HK";
    fetch(
      `${Api.path(window.location)}config/getByPath?path=menu.${endpoint}`,
      {
        method: "GET",
        headers: headers,
      }
    )
      .then(function (res) {
        let authToken = sessionStorage.getItem("auth");
        const project = sessionStorage.getItem("SELECTED_PROJECT");
        const asset = sessionStorage.getItem("SELECTED_ASSET");
        if (
          !authToken
          //  && !project && !asset
        ) {
          sessionStorage.removeItem("auth");
          sessionStorage.removeItem("SAVED_FORM_DETAILS");
          sessionStorage.setItem("auth", res.headers.get("authorization"));
          authToken = res.headers.get("authorization");
        }
        configReducer.dispatch({
          type: actionType.config.SET_TOKEN_NOT_NULL,
          payload: {
            hasToken: !!authToken,
          },
        });
        return res.json();
      })
      .then((resJson) => {
        const santizeStr = resJson.data.value
          .replace(/'/g, `"`)
          .replace(/，/g, `,`)
          .replace(/("title")/g, `title`)
          .replace(/("URL")/g, `URL`)
          .replace(/(title)/g, `"title"`)
          .replace(/(key\:)/g, `"key":`)
          .replace(/(URL)/g, `"URL"`);
        const menu = JSON.parse(santizeStr);
        sessionStorage.setItem(`${endpoint}-menu`, santizeStr);
        let menuArray;
        if (menu.length) {
          menuArray = menu;
        } else {
          menuArray = [menu];
        }
        configReducer.dispatch({
          type: actionType.config.SET_MENU_ITEMS,
          payload: {
            menu: menuArray,
            language: lng,
          },
        });
        sessionStorage.setItem("language", i18n.language);
      })
      .catch((error) => {
        console.log(error);
      });

    // get menu for other language to store
    const otherLangEndpoint = lng === "en" ? "zh-HK" : "en-US";
    fetch(
      `${Api.path(
        window.location
      )}config/getByPath?path=menu.${otherLangEndpoint}`,
      {
        method: "GET",
        headers: headers,
      }
    )
      .then(function (res) {
        return res.json();
      })
      .then((resJson) => {
        const santizeStr = resJson.data.value
          .replace(/'/g, `"`)
          .replace(/，/g, `,`)
          .replace(/("title")/g, `title`)
          .replace(/("URL")/g, `URL`)
          .replace(/(title)/g, `"title"`)
          .replace(/(key\:)/g, `"key":`)
          .replace(/(URL)/g, `"URL"`);
        sessionStorage.setItem(`${otherLangEndpoint}-menu`, santizeStr);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json; charset=utf-8",
    };
    fetch(`${Api.path(window.location)}config/getByPath?path=ciam.public-key`, {
      method: "GET",
      headers: headers,
    })
      .then(function (res) {
        return res.json();
      })
      .then((json) => {
        const publicKey = json.data.value;
        sessionStorage.removeItem("public_key");
        sessionStorage.setItem("public_key", publicKey);

        configReducer.dispatch({
          type: actionType.config.SET_PUBLIC_KEY,
          payload: { publicKey },
        });
        // configReducer.state.publicKey
        // console.info(json.data.value)
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (i18n.language !== configReducer.state.language) {
      const menuLang = i18n.language === "en" ? "en-US" : "zh-HK";
      const menu = JSON.parse(sessionStorage.getItem(`${menuLang}-menu`));
      window.recaptchaOptions = {
        lang: RecaptchaLg[i18n.language],
      };
      configReducer.dispatch({
        type: actionType.config.SET_MENU_ITEMS,
        payload: {
          menu,
          language: i18n.language,
        },
      });
      sessionStorage.setItem("language", i18n.language);
    }
  }, [i18n.language]);

  useEffect(() => {
    ReactGA.initialize("UA-138140644-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <>
      <LoadingOverlay active={configReducer.state.showLoading} spinner>
        <Header setShowMenu={setShowMenu} />
        <Drawer
          open={showMenu}
          onClose={() => {
            setShowMenu(false);
          }}
        >
          <div style={{ padding: 40 }}>
            {configReducer.state.menu && configReducer.state.menu.length > 0 ? (
              configReducer.state.menu.map((tap, index) => (
                <div key={index}>
                  <TapButton useChinese={useChinese} href={tap.URL}>
                    {tap.title}
                  </TapButton>
                </div>
              ))
            ) : (
              <Spinner animation="border" size="sm" variant="secondary" />
            )}
          </div>
        </Drawer>
        <ToastContainer autoClose={8000} />
        <div
          style={{
            width: "100%",
          }}
        >
          <AuthLoader />
          <ScrollToTop />
          <Switch>
            {/* <Route exact path={'/auth/guests/payment'} component={BillingDetail}/> */}
            <Route exact path="/" component={AssetListScreen} />
            <Route exact path={"/auth/user/landing"} component={AuthLanding} />
            <Route exact path={"/auth/user/nameplate"} component={Nameplate} />
            <Route
              exact
              path={"/auth/user/donation"}
              component={DonationForm}
            />
            <Route exact path={"/auth/payment/confirm"} component={Payment} />
            <Route
              exact
              path={"/auth/vipDonation/:type/:donationId/:accessKey"}
              component={VIPDonation}
            />
            {/*
                        <Route exact path={'/auth/retryDonation/:accessKey/:donationId'} component={Payment}/>
*/}
            <Route
              exact
              path={"/auth/retryDonation/:type/:donationId/:accessKey"}
              component={Payment}
            />
            <Route
              exact
              path={"/auth/payment/complete/successed"}
              component={Complete}
            />
            <Route
              exact
              path={"/auth/payment/complete/declined"}
              component={Complete}
            />
            <Route
              exact
              path={"/auth/payment/complete/waiting"}
              component={Complete}
            />
            <Route
              exact
              path={"/auth/donation/map/:project/:version"}
              component={DonorImage}
            />
            <Route
              exact
              path={"/auth/donation/map/:project/:version/:index"}
              component={DonorImage}
            />

            {/*
  <Route exact path="/donation/" component={AssetListScreen}/>
  */}
            <Route
              exact
              path="/donation/"
              component={() => {
                window.location.href = "/";
                return null;
              }}
            />
            <Route
              exact
              path="/donation"
              component={() => {
                window.location.href = "/";
                return null;
              }}
            />

            <Route
              exact
              path={"/donation/auth/user/landing"}
              component={AuthLanding}
            />
            <Route
              exact
              path={"/donation/auth/user/nameplate"}
              component={Nameplate}
            />
            <Route
              exact
              path={"/donation/auth/user/donation"}
              component={DonationForm}
            />
            <Route
              exact
              path={"/donation/auth/payment/confirm"}
              component={Payment}
            />
            <Route
              exact
              path={"/donation/auth/vipDonation/:accessKey/:donationId"}
              component={VIPDonation}
            />
            <Route
              exact
              path={"/donation/auth/retryDonation/:accessKey/:donationId"}
              component={Payment}
            />
            <Route
              exact
              path={"/donation/auth/payment/complete/successed"}
              component={Complete}
            />
            <Route
              exact
              path={"/donation/auth/payment/complete/declined"}
              component={Complete}
            />
            <Route
              exact
              path={"/donation/auth/payment/complete/waiting"}
              component={Complete}
            />
            <Route
              exact
              path={"/donation/auth/donation/map/:project/:version"}
              component={DonorImage}
            />
            <Route
              exact
              path={"/donation/auth/donation/map/:project/:version/:index"}
              component={DonorImage}
            />

            <Route
              path={"/forget-password"}
              component={() => {
                window.location.href =
                  "http://my.westkowloon.hk/en/my-westkowloon-forgot-password";
                return null;
              }}
            />

            <Route path="/ciam">
              <CIAMWrapper></CIAMWrapper>
            </Route>
            <Route component={NotFound} />
          </Switch>
        </div>

        <Footer />
        <AcceptCookie />
      </LoadingOverlay>
    </>
  );
};
// http://account-uat.westkowloon.hk/en/my-westkowloon-register?retUrl=https://support.westkowloon.hk/donation/auth/user/landing
export default AssetWrapper;
